export default "__VITE_ASSET__gOzx0JfG__"